module.exports = __webpack_public_path__ + "media/images/pc/plans/reason_01-be9141e805ac0ab1f7ef7273ac377a8f.jpg";